import { useImagings } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormButton, FormInputField, Modal, TextAreaField } from '@ui'
import { getError, showToast } from '@util'
import { Box, Form } from 'grommet'
import { FormProvider, useForm } from 'react-hook-form'
import { InferType } from 'yup'
import { addImagingSchema } from './AddImaging'

type Props = {
  onClose: () => void
  defaultData?: any
  id?: string
}

export const EditImaging = ({ onClose, defaultData, id }: Props) => {
  const { updateImaging } = useImagings()
  const methods = useForm({
    resolver: yupResolver(addImagingSchema),
    values: defaultData as InferType<typeof addImagingSchema>
  })
  const {
    handleSubmit,
    reset,
    formState: { isSubmitting }
  } = methods

  const onSubmit = async (data: any) => {
    const payload = {
      data: {
        attributes: {
          ...data
        },
        type: 'laboratories'
      }
    }

    try {
      await updateImaging({ data: payload, id: id || '' })
      showToast('Imaging updated successfully')
      onClose()
    } catch (error) {
      getError(error)
    }
  }

  const handleClose = () => {
    onClose()
    reset()
  }
  return (
    <FormProvider {...methods}>
      <Modal onClose={onClose} reset={reset} title="Edit Imaging">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box overflow="auto" pad={{ horizontal: '32px', vertical: '16px' }} width={'530px'}>
            <Box className="mx-auto w-full max-w-[399px]" flex={false} gap={'20px'}>
              <Box pad="0">
                <FormInputField label="Name" name="study_type" placeholder="" />
              </Box>
              <Box pad="0">
                <FormInputField label="Category" name="category" placeholder="" />
              </Box>
              <Box pad="0">
                <FormInputField label="Price" name="price" placeholder="" type="number" />
              </Box>
              <Box>
                <TextAreaField label="Description" name="description" />
              </Box>
            </Box>
          </Box>
          <FormButton isLoading={isSubmitting} onClose={handleClose} submit="Update" />
        </Form>
      </Modal>
    </FormProvider>
  )
}
